export const notificationsFormPath = {
  parent: "notification",
  newcounts: "new-notifications-counts",
  maxPages: "max-notifications-pages",
  paginationLoader: "notifications-next-page-loading",
  currentPage: "notifications-current-page",
};
